import { type ResourceId } from '@app/client';

// TODO: Why is this different from `helpers > ws > WebsocketTopicIds`?
export enum WebsocketTopic {
    AppRelease = 'AppRelease',
    Notification = 'Notification',
    OrderUpdated = 'OrderUpdated',
    EmojiTransferRequestAccepted = 'EmojiTransferRequestAccepted',
    FreeYatAssigned = 'FreeYatAssigned',
    WalletConnected = 'WalletConnected',

    // NFTs (New Yat)
    MultipleNftsAdded = 'MultipleNftsAdded',
    MultipleNftsRemoved = 'MultipleNftsRemoved',
    NftAdded = 'NftAdded',
    NftRemoved = 'NftRemoved',
    YatMinted = 'YatMinted',

    // Fantasy
    CompetitionSubmissionChange = 'CompetitionSubmissionChange',
    CompetitionLineupUpdated = 'CompetitionLineupUpdated',
}

enum WebsocketLevel {
    // Designates very serious errors.
    Error = 'Error',
    // Designates hazardous situations.
    Warn = 'Warn',
    // Designates useful information.
    Info = 'Info',
    // Designates lower priority information.
    Debug = 'Debug',
    // Designates very low priority, often extremely verbose, information.
    Trace = 'Trace',
}

interface WebsocketPayload<T> {
    action_id: ResourceId;
    data?: T;
    level: WebsocketLevel;
    message?: string;
}

export interface WebsocketMessage<T = unknown> {
    payload: WebsocketPayload<T>;
    topic: string;
}

export interface WebsocketMessageFlatPayload<T = unknown> extends Omit<WebsocketMessage<T>, 'payload'> {
    payload: T;
    result?: { status: string; topic: string };
}
